// https://www.w3.org/TR/wai-aria-practices-1.1/examples/tabs/tabs-1/tabs.html
(function () {
	function Tabs(nav_el) {
		const nav_button_el = nav_el.querySelector(`.btn`);
		if (!nav_button_el) {
			return;
		}

		const tabs = nav_el.querySelectorAll(`[role="tab"]`);
		if (tabs.length === 0) {
			return;
		}

		const panels = nav_el.parentNode.querySelectorAll(`[role="tabpanel"]`);
		if (panels.length === 0) {
			return;
		}

		// For easy reference
		const keys = {
			end: 35,
			home: 36,
			left: 37,
			right: 39,
		};

		// Add or substract depending on key pressed
		const direction = {
			37: -1,
			39: 1,
		};

		function open_nav() {
			nav_button_el.parentNode.classList.add(`open`);
			nav_button_el.setAttribute(`aria-expanded`, `true`);
		}

		function close_nav() {
			nav_button_el.parentNode.classList.remove(`open`);
			nav_button_el.setAttribute(`aria-expanded`, `false`);
		}

		// Deactivate all tabs and tab panels
		function deactivate_tabs() {
			for (let t = 0; t < tabs.length; t++) {
				tabs[t].setAttribute(`tabindex`, `-1`);
				tabs[t].setAttribute(`aria-selected`, `false`);
				tabs[t].removeEventListener(`focus`, focus_event_handler);
			}

			for (let p = 0; p < panels.length; p++) {
				panels[p].setAttribute(`hidden`, `hidden`);
			}
		}

		// Activates any given tab panel
		function activate_tab(tab, focus) {
			const set_focus = focus || true;

			// Deactivate all other tabs
			deactivate_tabs();

			// Remove tabindex attribute
			tab.removeAttribute(`tabindex`);

			// Set the tab as selected
			tab.setAttribute(`aria-selected`, `true`);

			// Get the value of aria-controls (which is an ID)
			const controls = tab.getAttribute(`aria-controls`);

			// Remove hidden attribute from tab panel to make it visible
			document.getElementById(controls).removeAttribute(`hidden`);

			// Set focus when required
			if (set_focus) {
				tab.focus();
			}

			for (let i = 0; i < tabs.length; i++) {
				if (tabs[i].getAttribute(`aria-controls`) !== controls) {
					continue;
				}

				if (i === 0) {
					window.history.pushState({}, ``, window.location.pathname);
				} else {
					window.history.pushState({}, ``, `#${controls}`);
				}

				break;
			}
		}

		// When a tab is clicked, activateTab is fired to activate it
		function click_event_listener(event) {
			const tab = event.currentTarget;
			activate_tab(tab, false);
			close_nav();
		}

		// Handle keydown on tabs
		function keydown_event_listener(event) {
			const key = event.keyCode;

			switch (key) {
				case keys.end:
					event.preventDefault();
					// Activate last tab
					activate_tab(tabs[tabs.length - 1]);
					break;
				case keys.home:
					event.preventDefault();
					// Activate first tab
					activate_tab(tabs[0]);
					break;
			}
		}

		// Make a guess
		function focus_first_tab() {
			tabs[0].focus();
		}

		// Make a guess
		function focus_last_tab() {
			tabs[tabs.length - 1].focus();
		}

		function focus_event_handler(event) {
			const target = event.target;

			const focused = document.activeElement;

			if (target === focused) {
				activate_tab(target, false);
			}
		}

		// Either focus the next, previous, first, or last tab
		// depening on key pressed
		function switch_tab_on_arrow_press(event) {
			const pressed = event.keyCode;

			for (let x = 0; x < tabs.length; x++) {
				tabs[x].addEventListener(`focus`, focus_event_handler);
			}

			if (direction[pressed]) {
				const target = event.target;
				if (typeof target.index !== `undefined`) {
					if (tabs[target.index + direction[pressed]]) {
						tabs[target.index + direction[pressed]].focus();
					} else if (pressed === keys.left) {
						focus_last_tab();
					} else if (pressed === keys.right) {
						focus_first_tab();
					}
				}
			}
		}

		// Handle keyup on tabs
		function keyup_event_listener(event) {
			const key = event.keyCode;

			switch (key) {
				case keys.left:
				case keys.right:
					switch_tab_on_arrow_press(event);
					break;
			}
		}

		function set_initial_tab() {
			const hash = window.location.hash.slice(1);

			for (const tab of tabs) {
				if (tab.getAttribute(`aria-controls`) !== hash) {
					continue;
				}

				activate_tab(tab);
				break;
			}
		}

		set_initial_tab();

		window.addEventListener(`hashchange`, set_initial_tab);

		// Bind listeners
		for (let i = 0; i < tabs.length; ++i) {
			tabs[i].addEventListener(`click`, click_event_listener);
			tabs[i].addEventListener(`keydown`, keydown_event_listener);
			tabs[i].addEventListener(`keyup`, keyup_event_listener);

			// Build an array with all tabs (<button>s) in it
			tabs[i].index = i;
		}

		nav_button_el.addEventListener(`click`, () => {
			if (nav_button_el.parentNode.classList.contains(`open`)) {
				close_nav();
			} else {
				open_nav();
			}
		});
	}

	const nav_els = document.querySelectorAll(`[role="tablist"]`);
	if (nav_els.length === 0) {
		return;
	}

	for (let i = 0; i < nav_els.length; i++) {
		new Tabs(nav_els[i]);
	}
})();
